// MF-67 — Standard row actions for the journal lists, using the app's IconTooltipButton + the same
// FontAwesome icons used across the other grids (preview / edit / delete) so they look consistent.
import IconTooltipButton from '../../../button/IconTooltipButton'

const RowActions = ({ onPreview, onFollowUp, onEdit, onDelete }) => (
  <div className='flex items-center justify-end'>
    {onPreview && <IconTooltipButton title='Preview' icon='expand-alt' onClick={onPreview} />}
    {onFollowUp && <IconTooltipButton title='Follow-up' icon='list-check' onClick={onFollowUp} />}
    {onEdit && <IconTooltipButton title='Edit' icon='pencil' onClick={onEdit} />}
    {onDelete && <IconTooltipButton title='Delete' icon={['fas', 'trash-alt']} onClick={onDelete} />}
  </div>
)

export default RowActions
